import { isAuthorized } from 'utils/Auth'
import { createReducer } from '../../utils'

export const INPUT_COUNTRY_TAX_REQUEST = 'sherrinford/country_tax/add/INPUT_COUNTRY_TAX_REQUEST'
export const INPUT_COUNTRY_TAX_SUCCESS = 'sherrinford/country_tax/add/INPUT_COUNTRY_TAX_SUCCESS'
export const INPUT_COUNTRY_TAX_ERROR = 'sherrinford/country_tax/add/INPUT_COUNTRY_TAX_ERROR'

export const IS_LOADING = 'sherrinford/country_tax/add/IS_LOADING'
export const DATA = 'sherrinford/country_tax/add/DATA'

const initialState = {
  data: {
    gcCountry: '',
    vat: 0,
    wht: 0,
    whtTin: 0,
    gcCommissionFee: 0,
    processingFee: 0,
    companyLegalName: '',
    taxNumber: '',
    address: '',
    bank: '',
    accountNumber: '',
    accountName: '',
    swiftCode: '',
    isDefault: false,
  },
  isLoading: false,
  isError: false,
  errorMessage: '',
}

export default createReducer(initialState, {
  [INPUT_COUNTRY_TAX_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [INPUT_COUNTRY_TAX_SUCCESS]: (state, data) => ({
    ...state,
    data,
    isLoading: false,
  }),
  [INPUT_COUNTRY_TAX_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),

  [IS_LOADING]: (state, data) => ({
    ...state,
    isLoading: data,
  }),

  [DATA]: (state, countryTax) => {
    const { data } = countryTax
    return {
      ...state,
      data,
    }
  },
})

export const setCountryTax = (data, cb) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      INPUT_COUNTRY_TAX_REQUEST,
      INPUT_COUNTRY_TAX_SUCCESS,
      INPUT_COUNTRY_TAX_ERROR,
    ],
    shuttle: {
      method: 'POST',
      path: '/country_tax',
      payloads: data,
      authorization: `${token}`,
      universeHost: true,
    },
    nextAction: (res) => {
      cb(res)
    },
  }
}

export const setData = data => ({
  type: [DATA],
  payload: data,
})

export const setLoadState = data => ({
  type: [IS_LOADING],
  payload: data,
})
